const moreSwatchesBindEventListeners = () => {
  document.querySelectorAll('.swatch-label.swatch-more').forEach((moreBtn) => {
    moreBtn.addEventListener('click', () => {
      moreBtn.parentNode.querySelectorAll('.swatch-label').forEach((swatchLabel) => {
        swatchLabel.classList.remove('hidden');
        moreBtn.classList.add('hidden');
      });
    });
  });
};
document.addEventListener('LoadMoreButtonBinding', (e) => moreSwatchesBindEventListeners(), false);

document.addEventListener('DOMContentLoaded', function () {
  moreSwatchesBindEventListeners();
});
